import InnerComponent from '@Components/Production/ManufacturingOrders/ManufacturingOrdersForm';
import orgContainer from '@Components/AppContainer';

const CreateManufacturingOrderPage = () => ((orgContainer(InnerComponent)));
export default CreateManufacturingOrderPage;
